import React from 'react'
import './Error.css'

import HomeBtn from '../../buttons/HomeBtn';


function Error() {
    return (
        <div id='center'>
            <div id='error-wrap'>
                <div id='error-msg'>
                    <h1>
                        OH NO!
                    </h1>
                    <h2>
                        It looks like this page doesn't exist!
                        <br />
                        Please return to the home page!
                    </h2>
                </div>
                <HomeBtn />
            </div>
        </div>
    )
}

export default Error